export default __webpack_public_path__ + "static/media/cz5.5b5eefbe.svg";